module.exports = {
    // BASE_URL: 'https://bestinbd.com/projects/web/2304NDE/wp-json/',
    // BASE_URL: 'https://infraconsultants.com/cms/wp-json/',
    // BASE_URL: 'https://beta.uccbd.com/cms/wp-json/',
    BASE_URL: 'https://uccbd.com/cms/wp-json/',
    MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}
